import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { LanguageFieldEnum } from 'Common/FieldEnum';
import { LANGUAGE_SETUP_FORM_NAME } from 'Common/FormEnum';
import { InputField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';

class LanguageSetupForm extends Component {
  render() {
    const { handleSubmit, isReadOnly } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <TitledCard title={'Notification Text'}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Field
                  label="Free"
                  name={LanguageFieldEnum.NotificationFree}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label="Incomplete"
                  name={LanguageFieldEnum.NotificationDeniedIncomplete}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Field
                  label="Reduced"
                  name={LanguageFieldEnum.NotificationReduced}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label="Denied Over Limit"
                  name={LanguageFieldEnum.NotificationDeniedMoney}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Field
                  label="Grace Period"
                  name={LanguageFieldEnum.NotificationGracePeriod}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label="Declined Benefits"
                  name={LanguageFieldEnum.NotificationDeclinedBenefits}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title={'Meal Benefit Expiration Text'}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Field
                  label="Status 2 Description"
                  name={LanguageFieldEnum.Status2Description}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label="Status 3 Description"
                  name={LanguageFieldEnum.Status3Description}
                  component={InputField}
                  type="text"
                  className="input--full"
                  readOnly={isReadOnly}
                />
                {/*
                Hidden ID field
              */}
                <Field
                  name={LanguageFieldEnum.Id}
                  component="input"
                  type="hidden"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        {/* <Button type="submit" disabled={isReadOnly}>
            Save
          </Button> */}
      </Form>
    );
  }
}

LanguageSetupForm = reduxForm({
  form: LANGUAGE_SETUP_FORM_NAME,
  enableReinitialize: true,
})(LanguageSetupForm);

export { LanguageSetupForm };



// WEBPACK FOOTER //
// ./src/pages/languagesetup/components/LanguageSetupForm.js